// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KrLu","label":"styles_label__22aBe"};